// @flow
export const SHOW_DOCUMENTS = "SHOW_DOCUMENTS";

export function showDocuments(partNumber: number) {
	return {
		type: SHOW_DOCUMENTS,
		partNumber
	};
}
